// @ts-nocheck
import * as Types from '../../../gql/generated/graphql.gen';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SignInPagesAuthorizeRecoveryCodeMutationVariables = Types.Exact<{
  recoveryCode: Types.Scalars['String']['input'];
}>;


export type SignInPagesAuthorizeRecoveryCodeMutation = { __typename?: 'Mutation', authorizeRecoveryCode: boolean };


export const SignInPagesAuthorizeRecoveryCodeDocument = gql`
    mutation signInPagesAuthorizeRecoveryCode($recoveryCode: String!) {
  authorizeRecoveryCode(recoveryCode: $recoveryCode)
}
    `;
export type SignInPagesAuthorizeRecoveryCodeMutationFn = Apollo.MutationFunction<SignInPagesAuthorizeRecoveryCodeMutation, SignInPagesAuthorizeRecoveryCodeMutationVariables>;

/**
 * __useSignInPagesAuthorizeRecoveryCodeMutation__
 *
 * To run a mutation, you first call `useSignInPagesAuthorizeRecoveryCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInPagesAuthorizeRecoveryCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInPagesAuthorizeRecoveryCodeMutation, { data, loading, error }] = useSignInPagesAuthorizeRecoveryCodeMutation({
 *   variables: {
 *      recoveryCode: // value for 'recoveryCode'
 *   },
 * });
 */
export function useSignInPagesAuthorizeRecoveryCodeMutation(baseOptions?: Apollo.MutationHookOptions<SignInPagesAuthorizeRecoveryCodeMutation, SignInPagesAuthorizeRecoveryCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInPagesAuthorizeRecoveryCodeMutation, SignInPagesAuthorizeRecoveryCodeMutationVariables>(SignInPagesAuthorizeRecoveryCodeDocument, options);
      }
export type SignInPagesAuthorizeRecoveryCodeMutationHookResult = ReturnType<typeof useSignInPagesAuthorizeRecoveryCodeMutation>;
export type SignInPagesAuthorizeRecoveryCodeMutationResult = Apollo.MutationResult<SignInPagesAuthorizeRecoveryCodeMutation>;
export type SignInPagesAuthorizeRecoveryCodeMutationOptions = Apollo.BaseMutationOptions<SignInPagesAuthorizeRecoveryCodeMutation, SignInPagesAuthorizeRecoveryCodeMutationVariables>;